<template>
  <div>
    <!-- content row -->
    <div class="row align-items-stretch">
      <!-- APP STATUS COLUMN -->
      <div
        id="app-status-column"
        class="col-lg-4 order-last order-lg-first pl-5 box-shadow"
      >
        <!-- nested elements container -->
        <div class="container-fluid">
          <div class="row">
            <!-- nested progress meter -->

            <div class="col-lg-12 col-md-6 col-sm-6 col-xs-12 pb-3">
              <h5>
                {{ this.message(this.$appdata.messages, "progress").label }}
              </h5>
              <Progress
                :completedSteps="completedSteps"
                :totalSteps="totalSteps"
              />
            </div>
            <!-- end nested progress meter -->

            <!-- nested guide -->
            <div class="col-lg-12 col-md-6 col-sm-6 col-xs-12">
              <h5>{{ this.message(this.$appdata.messages, "guide").label }}</h5>
              <blockquote class="speech-bubble">
                <div
                  v-html="
                    this.message(this.$appdata.messages, this.msgName).msg
                  "
                  style="background: #fff"
                ></div>
              </blockquote>
              <p>
                <img
                  class="avatar rounded-circle shadow"
                  src="assets/images/avataaars.png"
                />
              </p>
            </div>
            <!-- end nested guide -->
          </div>
          <!-- end nested elements row -->
        </div>
        <!-- end nested elements container -->
      </div>
      <!-- end app status column -->

      <!-- APP CONTENT COLUMN -->
      <div
        id="app-content-column"
        class="col-lg-8 col-md-12 order-first order-lg-lasts d-flex align-items-stretch"
      >
        <div class="box-shadow">
          <!-- CONTENT HERE -->
          <!-- back button -->
          <BackButton
            :active_key="active_key"
            :active_index="active_index"
            :issues="issues"
            @setProp="setProp"
          />
          <!-- end back button -->

          <div id="content-wrapper" class="container-fluid text-center">
            <div id="content-box" ref="contentBox">
              <Age
                :active_key="active_key"
                :active_index="active_index"
                @setProp="setProp"
                @enableNext="setProp"
              />

              <DeathBenefit
                :active_key="active_key"
                :active_index="active_index"
                @setProp="setProp"
                ref="death_benefit"
              />

              <Health
                :active_key="active_key"
                :active_index="active_index"
                :health_bracket="health_bracket"
                @setProp="setProp"
              />

              <Issues
                :active_key="active_key"
                :active_index="active_index"
                @setProp="setProp"
                :cls="issues_cls"
                :health_bracket="health_bracket"
                :issues="issues"
              />

              <RunNumbers
                :active_key="active_key"
                :active_index="active_index"
                :age="age"
                :dob="dob"
                :death_benefit="death_benefit"
                :health_bracket="health_bracket"
                :health_bracket_str="health_bracket_str"
                :issues="issues"
                :is_candidate="is_candidate"
                :estimate="estimate"
                @setProp="setProp"
              />

              <WebToLead
                :active_key="active_key"
                :age="age"
                :dob="dob"
                :death_benefit="death_benefit"
                :health_bracket="health_bracket"
                :health_bracket_str="health_bracket_str"
                :issues="issues"
                :is_candidate="is_candidate"
                @setProp="setProp"
              />

              <!-- end #slider -->

              <!-- next button -->

              <NextButton
                :nextDisabled="nextDisabled"
                :active_key="active_key"
                :active_index="active_index"
                :health_bracket="health_bracket"
                @setProp="setProp"
              />
            </div>
            <!-- end content box -->
          </div>
          <!-- end box-shadow -->
        </div>
        <!-- end content wrapper -->
      </div>
      <!-- end app content column -->
    </div>
    <!-- end content row -->
  </div>
  <!-- end app-wrapper -->
</template>
<script>
import { benefitCalculator } from "@/mixins/benefitCalculator.js";
import { messaging } from "@/mixins/messaging.js";
import { navigation } from "@/mixins/navigation.js";
export default {
  mixins: [messaging, benefitCalculator, navigation],
  components: {
    Progress: () => import("@/components/Progress.vue"),
    BackButton: () => import("@/components/BackButton.vue"),
    NextButton: () => import("@/components/NextButton.vue"),
    Age: () => import("@/components/Age.vue"),
    DeathBenefit: () => import("@/components/Policy.vue"),
    Health: () => import("@/components/Health.vue"),
    Issues: () => import("@/components/Issues.vue"),
    RunNumbers: () => import("@/components/RunNumbers.vue"),
    WebToLead: () => import("@/components/WebToLead.vue"),
  },
  data() {
    return {
      active_key: 0,
      active_index: [
        "age",
        "death_benefit",
        "health",
        "issues",
        "numbers",
        "wtl",
      ],
      age: 0,
      death_benefit: 0,
      health_bracket: 1,
      health_bracket_str: "Healthy/Average",
      issues: [],
      nextDisabled: "disabled",
      backDisabled: false,
      msgNames: ["intro", "policy", "health", "issues", "numbers", "wtl"],
      issues_cls: "component out",
    };
  },
  methods: {
    setProp: function (v) {
      this[v.prop] = v.value;
      return;
    },
  },
  computed: {
    totalSteps: function () {
      return this.active_index.length;
    },
    completedSteps: function () {
      return this.active_key + 1;
    },
    current_year: function () {
      var d = new Date();
      return d.getFullYear();
    },
    dob: function () {
      var y = this.current_year - this.age;
      return "01/01/" + y;
    },
    msgName: function () {
      return this.msgNames[this.active_key];
    },
  },
  watch: {
    active_key: function () {
      this.setProp("nextDisabled", "disabled");
    },
  },
  mounted: function () {
    this.$cookie.delete(this.$appdata.ck_name);
  },
};
</script>
